export function findInArray(filterValArr, optionArr) {
    return optionArr.filter(obj => filterValArr.find(val => val.businessName == obj.businessName));
}

export function mapToNewArray(dataSet, mapField = 'name') {
    if (dataSet.length) {
        return dataSet.map(obj => ({
            id: Number(obj.id + ""),
            businessName: obj[mapField],
            count: obj?.count != null ? obj.count : null
        }))
    }
    return []
}

export function mapToNewArrayCities(dataSet, id = 'id', mapField = 'name') {
    if (dataSet.length) {
        return dataSet.map(obj => ({
            id: Number(obj[id] + ""),
            businessName: obj[mapField],
            cities: obj.cities ? mapToNewArray(obj.cities) : []
        }))
    }
    return []
}

export function mapToNewArrayWithState(dataSet, stateName, mapField = 'name') {
    if (dataSet.length) {
        return dataSet.map(obj => ({
            id: Number(obj.id + ""),
            name: `${stateName} - ${obj[mapField]}`
        }))
    }
    return []
}

export function mapToCitiesGroup(dataSet, id = 'id', mapField = 'name') {
    if (dataSet.length) {
        return dataSet.map(obj => ({
            id: Number(obj[id] + ""),
            name: obj[mapField],
            cities: obj.cities ? mapToNewArrayWithState(obj.cities, obj[mapField]) : []
        }))
    }
    return []
}

export function getFormattedLead(leads, colsList, phoneConfig, emailConfig, socialConfig) {
    const activeCustomFieldList = [];
    colsList.map(fieldObj => {
        if (fieldObj.custom == true && fieldObj.ischecked == true) {
            activeCustomFieldList.push(fieldObj)
        }
    });

    return leads.map((account) => {
        if (account.accountEmails && account.accountEmails.length) {
            const emailFieldData = account.accountEmails;
            emailFieldData.forEach(emailDataObj => {
                const dataField = emailConfig.find(emailtype => emailDataObj.email && emailDataObj.email.emailTypeId && emailtype.id == emailDataObj.email.emailTypeId)
                if (dataField) {
                    account[dataField.code] = emailDataObj.emailAddress
                }
            });
        }
        if (account.accountPhones && account.accountPhones.length) {
            const emailFieldData = account.accountPhones;
            emailFieldData.forEach(phoneDataObj => {
                const dataField = phoneConfig.find(phoneltype => phoneDataObj.phone && phoneDataObj.phone.phoneTypeId && phoneltype.id == phoneDataObj.phone.phoneTypeId)
                if (dataField) {
                    account[dataField.code] = phoneDataObj.phoneNumber
                }
            });
        }
        if (account.accountSocials && account.accountSocials.length) {
            const emailFieldData = account.accountSocials;
            emailFieldData.forEach(socialDataObj => {
                const dataField = socialConfig.find(socialType => socialDataObj.socialProfile && socialDataObj.socialProfile.socialProfileTypeId && socialType.id == socialDataObj.socialProfile.socialProfileTypeId)
                if (dataField) {
                    account[dataField.code] = socialDataObj.socialProfile.name
                }
            });
        }
        if (activeCustomFieldList.length) {
            activeCustomFieldList.map((customField) => {
                const newVal = getCustomFieldValue(customField, account.customAttributeValues)
                account[customField.field] = newVal;
            })
        }
        const data = {
            ...account,
        }
        // data['createdDate'] = data['createdDate'] ? this.localDatePipe.transform(data['createdDate'],'date') : null;
        // data['updatedDate'] = data['updatedDate'] ? this.localDatePipe.transform(data['updatedDate'],'date') : null;
        return data;
    })
}

export function getFormattedAccount(accounts, colsList, phoneConfig, emailConfig, socialConfig) {
    const activeCustomFieldList = [];
    colsList.map(fieldObj => {
        if (fieldObj.custom == true && fieldObj.enabled == true) {
            activeCustomFieldList.push(fieldObj)
        }
    });

    return accounts.map((account) => {
        if (account.accountEmails && account.accountEmails.length) {
            const emailFieldData = account.accountEmails;
            emailFieldData.forEach(emailDataObj => {
                const dataField = emailConfig.find(emailtype => emailDataObj.email && emailDataObj.email.emailTypeId && emailtype.id == emailDataObj.email.emailTypeId)
                if (dataField) {
                    account[dataField.code] = emailDataObj.emailAddress
                }
            });
        }
        if (account.accountPhones && account.accountPhones.length) {
            const emailFieldData = account.accountPhones;
            emailFieldData.forEach(phoneDataObj => {
                const dataField = phoneConfig.find(phoneltype => phoneDataObj.phone && phoneDataObj.phone.phoneTypeId && phoneltype.id == phoneDataObj.phone.phoneTypeId)
                if (dataField) {
                    account[dataField.code] = phoneDataObj.phoneNumber
                }
            });
        }
        if (account.accountSocials && account.accountSocials.length) {
            const emailFieldData = account.accountSocials;
            emailFieldData.forEach(socialDataObj => {
                const dataField = socialConfig.find(socialType => socialDataObj.socialProfile && socialDataObj.socialProfile.socialProfileTypeId && socialType.id == socialDataObj.socialProfile.socialProfileTypeId)
                if (dataField) {
                    account[dataField.code] = socialDataObj.socialProfile.name
                }
            });
        }
        if (activeCustomFieldList.length) {
            activeCustomFieldList.map((customField) => {
                const newVal = getCustomFieldValue(customField, account.customAttributeValues)
                account[customField.field] = newVal;
            })
        }
        const data = {
            ...account,
        }
        // data['createdDate'] = data['createdDate'] ? this.localDatePipe.transform(data['createdDate'],'date') : null;
        // data['updatedDate'] = data['updatedDate'] ? this.localDatePipe.transform(data['updatedDate'],'date') : null;
        return data;
    })
}

export function getCustomFieldValue(customFieldName, customAttributeValues) {
    let value: any = '';
    if (customAttributeValues && customAttributeValues.length) {

        const matchedValue = customAttributeValues.find(customAttributeValue => customAttributeValue.customAttribute.fieldName == customFieldName.labelname);
        if (matchedValue) {
            switch (matchedValue.customAttribute.formControlId) {
                case 1: // DropdownList
                    value = matchedValue.value ? JSON.parse(matchedValue.value).name : null;
                    break;
                case 2: // Checkbox
                    value = matchedValue.value ? JSON.parse(matchedValue.value).join() : null;
                    break;
                case 3: // Radio
                    value = matchedValue.value ? matchedValue.value : null;
                    break;
                case 4: // Toggle
                    value = matchedValue.value;
                    break;
                case 7: // Rating
                    value = matchedValue.value;
                    break;
                case 8: // Input
                    value = matchedValue.value;
                    break;
                case 9: // 9 = datepicker
                    value = matchedValue.value ? matchedValue.value : ''; // this.localDatePipe.transform(matchedValue.value,'date') : '';
                    break;
                case 11: // MultipleDropDownList
                    const arrVal = matchedValue.value ? JSON.parse(matchedValue.value) : [];
                    if (arrVal.length) {
                        value = arrVal.map(val => val.name).join(', ')
                    } else {
                        value = '';
                    }
                    break;
            }

        }

    }
    return value;
}

export function sort(data, field) {
    return data.sort((a, b) => a[field].localeCompare(b[field]));
}

export function addInActiveInList(dataArr, selectedList) {
    const inActiveList = selectedList.filter(obj => obj?.statusId == 2);
    if (inActiveList.length) {
        dataArr = [...dataArr, ...inActiveList];
        return sort(dataArr, 'name');
    } else {
        return dataArr;
    }
}

export function addInList(dataArr, newItem, sortFieldName = 'name') {
    if (dataArr) {
        dataArr = [...dataArr, newItem];
    } else {
        dataArr = [newItem];
    }
    return sort(dataArr, sortFieldName);
}

export function getFlatCols(colArr) {
    let fieldArr = [];
    colArr.forEach(element => {
        element.fields.forEach(field => {
            if (field.fieldTypes && field.fieldTypes.fields) {
                // field.ischecked = false
                fieldArr = [...fieldArr, ...field.fieldTypes.fields];
            }
            fieldArr.push(field);
            if (field?.childFields?.length > 0) {
                for (const childFieldData of field.childFields) {
                    fieldArr.push(childFieldData);
                }
            }
        });
        //fieldArr = fieldArr.length ? [...fieldArr, ...element.fields]  : [...element.fields];
    });
    return fieldArr;
}

export function getAccountLeadFlatColsImport(colArr) {
    let fieldArr = [];

    colArr.forEach(element => {
        fieldArr.push({
            name: element.name,
            labelname: element.name,
            sectionHeader: true,
            ischecked: true,
            fields: null,
        });

        element.fields.forEach(field => {
            if (field.childFields?.length) {
                fieldArr = [...fieldArr, ...field.childFields];
            }

            fieldArr.push(field);
        });
    });

    return fieldArr;
}

export function getFlatColsImport(colArr) {
    let fieldArr = [];

    colArr.forEach(element => {
        fieldArr.push({
            name: element.name,
            labelname: element.name,
            sectionHeader: true,
            ischecked: true,
            fieldTypes: null,
        });

        element?.fields?.forEach(field => {

            if (field.fieldTypes && field.fieldTypes.fields) {
                fieldArr = [...fieldArr, ...field.fieldTypes.fields];
            }

            fieldArr.push(field);
        });
    });

    return fieldArr;
}

export function checkAreSame(firstString: string, secondString: string): boolean {
    let matched = (firstString.toLowerCase() === secondString.toLowerCase()) || (firstString.includes(secondString));

    if (matched) {
        // console.log(true)
        return true;
    }

    let obj1 = {};
    let obj2 = {};

    for (let el of firstString) {
        if (el => 'A' && el <= 'Z') {
            el = el.toLowerCase();
        }

        if (obj1[el]) {
            ++obj1[el];
        } else {
            obj1[el] = 1;
        }
    }

    for (let el of secondString) {
        if (el => 'A' && el <= 'Z') {
            el = el.toLowerCase();
        }

        if (obj2[el]) {
            ++obj2[el];
        } else {
            obj2[el] = 1;
        }
    }

    let count = 0;

    for (let key of Object.keys(obj1)) {
        if (!obj2[key]) {
            obj2[key] = 0;
        }

        if ((Math.abs(obj1[key] - obj2[key]) >= 2 && obj2[key] > 0) || obj2[key] === 0) {
            // console.log(false)
            return false;
        }
    }

    for (let key of Object.keys(obj2)) {
        if (!obj1[key]) {
            obj1[key] = 0;
        }

        if ((Math.abs(obj2[key] - obj1[key]) >= 2 && obj1[key] > 0) || obj1[key] === 0) {
            // console.log(false)
            return false;
        }
    }

    // console.log(true)
    return true;
}

export function secondsToDhms(seconds) {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? " hr " : " hrs ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " min " : " mins ") : "";
    var sDisplay = s >= 0 ? s + (s == 1 ? " sec" : " secs") : "";
    return dDisplay + hDisplay + mDisplay + (m < 1 ? sDisplay : '');
}
